import { render, staticRenderFns } from "./IndustrialStrataIndustrialUnit.vue?vue&type=template&id=6a4b3848&scoped=true&"
import script from "./IndustrialStrataIndustrialUnit.vue?vue&type=script&lang=ts&"
export * from "./IndustrialStrataIndustrialUnit.vue?vue&type=script&lang=ts&"
import style0 from "./IndustrialStrataIndustrialUnit.vue?vue&type=style&index=0&id=6a4b3848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b3848",
  null
  
)

export default component.exports